import Block from "@/components/Block"
import Box from "@/components/Box"
import Flex from "@/components/Flex"
import Typography from "@/components/Typography"
import styled from "@emotion/styled"
import React from "react"
import { useTranslation } from "react-i18next"
import { Container } from "../components/Container"
import Card from "../components/MerchantCard"
import { useMerchantCardData } from "../hooks/useMerchantCardData"
import { DownloadAppBlock } from "./DownloadAppBlock"

const GradientText = styled(Typography)`
  background: linear-gradient(90deg, #1199fa 0%, #0b1426 100%);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
`

export const MerchantSection = ({
  title,
  maxWidth,
}: {
  title: string
  maxWidth: any[]
}) => {
  const { t } = useTranslation("payCustomer")
  const { nike, apple, adidas, ledger, starbucks } = useMerchantCardData()
  return (
    <Block backgroundColor={"#FFF"}>
      <Container>
        <GradientText
          textAlign={"center"}
          as="h2"
          variant="h2"
          maxWidth={maxWidth}
          mx={"auto"}
          mb={[6, 2, 5]}
        >
          {t(title)}
        </GradientText>
        <Box display={["none", "none", "flex"]} customCss={{ gap: 2 }}>
          <Flex flexDirection={"column"} customCss={{ gap: 2 }}>
            <Flex customCss={{ gap: 2 }}>
              <Card text={t("newMerchant.ledger")} cardStyle={ledger} />
              <Card
                text={t("newMerchant.starbucks")}
                textColor="#0B1426"
                direction="right"
                cardStyle={starbucks}
              />
            </Flex>
            <Flex customCss={{ gap: 2 }}>
              <Card
                text={t("newMerchant.nike")}
                textColor="#0B1426"
                cardStyle={nike}
              />
              <DownloadAppBlock />
            </Flex>
          </Flex>
          <Flex flexDirection={"column"} customCss={{ gap: 2 }}>
            <Card text={t("newMerchant.apple")} cardStyle={apple} />
            <Card text={t("newMerchant.adidas")} cardStyle={adidas} />
          </Flex>
        </Box>
        <Box
          display={["none", "flex", "none"]}
          flexDirection={"column"}
          customCss={{ gap: 2 }}
        >
          <Flex customCss={{ gap: 2 }}>
            <Card
              text={t("newMerchant.nike")}
              textColor="#0B1426"
              cardStyle={nike}
            />
            <Card
              text={t("newMerchant.starbucks")}
              textColor="#0B1426"
              direction="right"
              cardStyle={starbucks}
            />
          </Flex>
          <DownloadAppBlock />
          <Flex customCss={{ gap: 2 }}>
            <Card text={t("newMerchant.ledger")} cardStyle={ledger} />
            <Card text={t("newMerchant.adidas")} cardStyle={adidas} />
            <Card text={t("newMerchant.apple")} cardStyle={apple} />
          </Flex>
        </Box>
        <Box
          display={["flex", "none", "none"]}
          flexDirection={"column"}
          customCss={{ gap: 2 }}
        >
          <Card text={t("newMerchant.ledger")} cardStyle={ledger} />
          <Card
            text={t("newMerchant.nike")}
            cardStyle={nike}
            textColor="#0B1426"
          />
          <DownloadAppBlock />
          <Card
            text={t("newMerchant.starbucks")}
            cardStyle={starbucks}
            textColor="#0B1426"
            direction="right"
          />
          <Card text={t("newMerchant.apple")} cardStyle={apple} />
        </Box>
      </Container>
    </Block>
  )
}
